import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
//import {store, persistor} from './store';  //config set for maintaining state memory through broswer
//import { PersistGate } from 'redux-persist/integration/react';
import App from './components/App';
import reducers from './reducers';


const store = createStore(reducers, applyMiddleware(thunk));  //add thunk to redux store
ReactDOM.render(
    <StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </StrictMode>
    ,
    document.querySelector('#root'),
);